import React, { useState } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import MDXRenderer from 'gatsby-plugin-mdx/mdx-renderer'
import { MDXProvider } from '@mdx-js/react'
import { flatten, get } from 'lodash'
import Sticky from 'react-sticky-el'

import { ReactComponent as Arrow } from '../../gfx/arrow-expand.svg'
import { ReactComponent as Yes } from '../../gfx/yes.svg'
import { ReactComponent as No } from '../../gfx/no.svg'

import './style.scss'

const components = {
  Yes,
  No,
  TD: ({ children }) => <td className="p-2">{children}</td>,
  TH: ({ children }) => <th className="p-2">{children}</th>,
  h2: ({ children }) => (
    <h2 className="c-product-table__sub-title">{children}</h2>
  ),
  table: ({ children }) => (
    <div className="position-relative">
      <Sticky
        boundaryElement=".c-product-table-wrapper"
        style={{
          position: 'relative',
          zIndex: 100,
        }}
        hideOnBoundaryHit={false}
        // bottomOffset={80}
        hideOnBoundaryHit={false}
      >
        <table className="c-product-table c-product-table--sticky">
          {children}
        </table>
      </Sticky>

      <table className="c-product-table">{children}</table>
    </div>
  ),
  tr: props => {
    // add an extra class name to rows which contain an h2
    const titles = flatten(
      React.Children.toArray(props.children).map(cell =>
        React.Children.toArray(cell.props.children)
      )
    ).filter(child => get(child, 'props.originalType') === 'h2')

    return (
      <tr className={titles.length ? 'c-product-table__title-row' : ''}>
        {props.children}
      </tr>
    )
  },
}

const ProductTable = () => {
  const [activeProductIndex, setActiveProductIndex] = useState(1)
  const [filterIsOpen, setFilterIsOpen] = useState(false)

  const {
    products,
    mdx: {
      body
    },
  } = useStaticQuery(graphql`
    query {
      products: allMarkdownRemark(
        filter: { frontmatter: { type: { eq: "product" } } }
      ) {
        edges {
          node {
            fields {
              slug
            }
            frontmatter {
              title
              targetMarket
              color
              icon {
                id
                publicURL
              }
            }
          }
        }
      }

      mdx(frontmatter: { id: { eq: "product-comparison" } }) {
        id
        fields {
          slug
        }
        body
      }
    }
  `)

  function getProduct(slug) {
    const product = products.edges.filter(({ node }) => {
      return node.fields.slug === slug
    })

    if (product.length < 1) return null

    return product[0]
  }

  const ProductFilter = ({ children }) => {
    return (
      <Sticky
        boundaryElement=".c-product-table-wrapper"
        style={{
          position: 'relative',
          zIndex: 100,
        }}
        hideOnBoundaryHit={false}
        // bottomOffset={80}
        hideOnBoundaryHit={false}
      >
        <div
          onClick={() => {
            setFilterIsOpen(!filterIsOpen)
          }}
          className={`c-product-table-filter ${
            filterIsOpen ? 'product-filter-is-open' : ''
          }`}
        >
          {children}
        </div>
      </Sticky>
    )
  }

  const ProductOption = ({ slug, index }) => {
    console.log(slug);
    const product = getProduct(slug)
    const {
      frontmatter: { title, targetMarket, icon, color },
    } = product.node

    const isActive = index == activeProductIndex

    return (
      <button
        className={`c-product-table-filter-option ${
          isActive ? 'is-active' : ''
        } `}
        style={{ '--theme-color': color }}
        onClick={() => {
          setActiveProductIndex(index)
        }}
      >
        <img
          src={icon.publicURL}
          className="c-product-table-filter-option__icon mr-2"
        />
        <span className="c-product-table-filter-option__label">{title}</span>

        {isActive && (
          <div className="c-product-table-filter-option__expand ml-auto">
            <Arrow />
          </div>
        )}
      </button>
    )
  }

  const ProductCard = ({ slug }) => {
    const product = getProduct(slug)

    if (!product) return ''

    const {
      frontmatter: { title, targetMarket, icon, color },
    } = product.node
    return (
      <div
        className="c-product-table-card px-1 py-3"
        style={{ '--theme-color': color }}
      >
        <img
          className="c-product-table-card__logo mx-auto mb-2"
          src={icon.publicURL}
          alt={title}
        />
        <div className="c-product-table-card__target text-uppercase">
          {targetMarket}
        </div>
        <h2 className="c-product-table-card__title my-1">{title}</h2>
        <div className="mt-auto ">
          <a className="c-product-table-card__button" href={slug}>
            Get started
          </a>
        </div>
      </div>
    )
  }

  return (
    <div
      className={`active-product-index-${activeProductIndex} container mb-5 c-product-table-wrapper`}
    >
      <MDXProvider
        components={{
          ...components,
          ProductCard,
          ProductFilter,
          ProductOption,
        }}
      >
        <MDXRenderer>{body}</MDXRenderer>
      </MDXProvider>
    </div>
  )
}

export default ProductTable
